import { ISSUE_ATTRIBUTE_NAMES } from '../../constants/issue-attribute-names';
import CommonTextarea from './components/CommonTextarea';

const SuggestedAnswer = () => (
  <CommonTextarea fieldName={ISSUE_ATTRIBUTE_NAMES.SUGGESTED_ANSWER} label="new.suggestedAnswer" />
);

export default SuggestedAnswer;
